// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuShopButton_wrapper__20OQ5","button":"MenuShopButton_button__nthGs","button-text":"MenuShopButton_button-text__15Sq3"};